import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api/v1' 
  : 'http://localhost:3001/api/v1';

const AlexaLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();

  const [backendAuthUrl, setBackendAuthUrl] = useState('');

  useEffect(() => {
    // console.log('--- ALEXA LOGIN PAGE MOUNTED ---');
    // We need to construct the action URL for the form dynamically
    // to include all the query parameters passed by Alexa.
    const params = new URLSearchParams(location.search);
    const debugData = {
      client_id: params.get('client_id'),
      redirect_uri: params.get('redirect_uri'),
      state: params.get('state'),
    };
    // console.log('Received parameters from Alexa:', debugData);
    
    // The form will POST back to the same endpoint that rendered it.
    setBackendAuthUrl(`/api/v1/auth/alexa/auth?${params.toString()}`);
    // console.log('Form will POST to this URL:', backendAuthUrl);

  }, [location, backendAuthUrl]);


  return (
    <div style={{ fontFamily: 'sans-serif', padding: '20px', maxWidth: '400px', margin: '50px auto', border: '1px solid #ccc', borderRadius: '5px' }}>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <img src="https://via.placeholder.com/50" alt="App Logo" style={{ borderRadius: '50%' }} />
        <h2>Link with Kanto</h2>
        <p>Enter your Kanto account details to link with Alexa.</p>
      </div>
      
      {error ? (
          <div style={{color: 'red', margin: '10px 0'}}>{error}</div>
        ) : null}

        <form method="post" action={backendAuthUrl}>
          <div style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}
              required 
              style={{ width: '100%', padding: '8px', boxSizing: 'border-box', marginTop: '5px' }} 
            />
          </div>
          <div style={{ marginBottom: '20px', textAlign: 'left' }}>
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
              style={{ width: '100%', padding: '8px', boxSizing: 'border-box', marginTop: '5px' }}
            />
          </div>
          <button type="submit" style={{ width: '100%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Link Account
          </button>
        </form>
    </div>
  );
};

export default AlexaLoginPage; 